export default {
  sidebar: {
    manageLegalAccount: "مدیریت حساب حقوقی",
    managePasswordUsername2FA:
      "مدیریت رمز عبور، نام کاربری و احراز هویت دو عاملی",
    personalAccountSignin: "ورود به حساب شخصی",
    legalAccountDashboard: "داشبورد حساب حقوقی",
    signatureCartable: "کارتابل امضا",
    viewLicensesForRequests: "مشاهده مجوزها برای تایید یا عدم تایید درخواست ها",
    manageTransactions: "مدیریت تراکنش ها",
    personalContactAndIDPhoto: "اطلاعات فردی، اطلاعات تماس و عکس احراز هویت",
    bankInfoAndAddresses: "اطلاعات بانکی و آدرس‌ها",
    walletAddressesAndBankAccounts:
      "آدرس کیف پول‌ها، شماره‌های شبا و کارت‌های بانکی",
    identityInformation: "اطالاعات هویتی",
    youAreInLegalAccount: "شما اکنون در حساب حقوقی خود هستید"
  },
  mainDashboard: {
    legalAccountSignin: "شما وارد حساب حقوقی خود شده اید",
    dontShowAgain: "دیگر نشانم نده"
  },
  corporateDashboard: {
    legalCompaniesRules: "قوانین و مقررات شرکت های حقوقی",
    legalCompaniesRulesDescription:
      "شما میتوانید در این قسمت به قوانین شرکت های حقوقی را مطالعه نمایید"
  },
  manage: {
    createLegalAccount: "ایجاد حساب حقوقی",
    createLegalAccountDescription:
      "شما در این قسمت میتوانید حساب حقوقی خود را ایجاد کنید",
    legalAccountsList: "لیست حساب های حقوقی",
    legalAccountsListDescription:
      "در این قسمت لیست شرکت های ساخته شده خود را میتوانید ببینید",
    legalAccountNote:
      "توجه داشته باشید برای پیشبرد سریع‌تر برای ایجاد حساب حقوقی می‌بایست تمامی اعضای شرکت در اکسکوینو حساب کاربری داشته و احراز هویت به صورت کامل انجام شده باشد",
    create: {
      step1: {
        legalAccountInstructions:
          "برای ایجاد حساب حقوقی نیاز هست فایل زیر دانلود و مدارک خود را براساس موارد ذکر شده به درستی و بادقت وارد و در صفحه بعد آپلود کنید.",
        companyName: "نام شرکت",
        companyMembersCount: "تعداد نفرات اعضای امضا دار شرکت",
        requiredDocumentsFile: "فایل مدارک مورد نیاز",
        submitAndContinue: "ثبت و ادامه",
        uploadDocuments: "بارگذاری مدارک",
        reviewDocuments: "بررسی مدارک",
        editLegalAccountDocuments: "اصلاح مدارک حساب های حقوقی",
        documentsNeedCorrection:
          "موارد زیر نیازمند اصلاح هستند و باید مجدداً بارگذاری شوند.",
        viewAllCompanyMembersAccess: "مشاهده دسترسی همه اعضای شرکت",
        deposit: "واریز",
        active: "فعال",
        withdrawal: "برداشت",
        requiresAllMembersApproval: "نیاز به تایید همه اعضا",
        spotTrades: "معاملات اسپات",
        OTCTrades: "معاملات OTC",
        staking: "استیکینگ",
        transferToMarketWallet: "انتقال به ولت مارکت"
      },
      step2: {
        uploadRequiredDocuments:
          "در این قسمت نیاز هست مدارک مدنظر را بارگذاری کنید",
        allowedFileFormats: "فرمت مجاز فایل: {formats}"
      },
      step3: {
        legalAccountRequestSubmitted:
          "درخواست ایجاد حساب حقوقی شما با موفقیت ثبت شد",
        legalAccountNextSteps:
          "بعد از تایید شرایط شما میتوانید از طریق پنل پروفایل وارد حساب حقوقی خود شوید. در صورتی که مدارک مورد تایید نباشد از طریق پشتیبانی و یا ایمیل برای اصلاح مدارک به اطلاع شما میرسد."
      }
    }
  },
  companyInformation: {
    companyInformation: "اطلاعات شرکت",
    companyInformationNote:
      "به تاریخ سالنامه شرکت میبایست توجه داشت زیرا در تاریخ سررسید میبایست مدارکی را برای ادامه فعالیت برای ما ارسال نمایید",
    annualBookDate: "تاریخ سالنامه",
    companyName: "نام شرکت",
    nationalID: "شناسه ملی",
    establishmentDate: "تاریخ تاسیس",
    userType: "نوع کاربر",
    legal: "حقوقی"
  },
  permissionsCartable: {
    licensesCartable: "کارتابل مجوزها",
    noWithdrawalFound: "هیچ برداشتی یافت نشد",
    withdrawal: "برداشت",
    requester: "درخواست کننده",
    cryptoWithdrawal: "برداشت رمزارز",
    rialWithdrawal: "برداشت ریال"
  },
  membersList: {
    signersList: "لیست صاحبان امضا"
  },
  guideCard: {
    legalAccountReminder:
      "توجه داشته باشید برای پیشبرد سریع‌تر برای ایجاد حساب حقوقی می‌بایست تمامی اعضای شرکت در اکسکوینو حساب کاربری داشته و احراز هویت به صورت کامل انجام شده باشد."
  },
  signCreate: {
    confirmLegalAccountCreation:
      "شما با تایید در این صفحه اجازه ی ایجاد شرکت به عنوان اعضای اصلی را اعلام مینمایید",
    acceptLegalAccountRules:
      "با مطالعه قوانین بالا میپذیرم شرکت حقوقی ایجاد شود",
    revokeLegalAccountPermission: "لغو مجوز ایجاد شرکت",
    revokeLegalAccountPermissionConfirmation:
      "آیا مطمئن هستید می‌خواهید این مجوز را لغو کنید؟ برای ایجاد حساب حقوقی نیاز هست که همه ی اعضا شرایط ایجاد شرکت را بپذیرند",
    revokeLegalAccountPermissionConfirmButton: "مطمئنم، لغوش کن"
  },
  signCrypto: {
    currencyType: "نوع ارز",
    youSend: "ارسال میکنید",
    destinationWalletAddress: "آدرس کیف پول مقصد",
    networkType: "نوع شبکه",
    amountExcludingFee: "مبلغ بدون کسر کارمزد",
    fee: "کارمزد",
    description: "توضیحات",
    cancelTransaction: "لغو تراکنش",
    submitSignature: "ثبت امضا",
    youReceive: "دریافت می‌کنید",
    orderNumber: "شماره سفارش",
    accountHolderName: "نام دارنده حساب",
    shebaNumber: "شماره شبا",
    revokeConfirmation: "آیا مطمئن هستید می‌خواهید این مجوز را لغو کنید؟"
  }
};
